import { render, staticRenderFns } from "./ChoosePermissionField.vue?vue&type=template&id=4ad960b6"
import script from "./ChoosePermissionField.vue?vue&type=script&lang=js"
export * from "./ChoosePermissionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports